export default __webpack_public_path__ + "static/media/radio-surgery.86341132.pdf";